import { render } from "./carouselErstbeschreibungenHandy.vue?vue&type=template&id=4b2aafac"
import script from "./carouselErstbeschreibungenHandy.vue?vue&type=script&lang=js"
export * from "./carouselErstbeschreibungenHandy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__